import React, { useMemo } from 'react'
import Breadcrumb from '../../components/common/Breadcrumb'
import ReactDataTable from 'react-data-table-component';
import { avatar1, avatar10, avatar11, avatar12, avatar13, avatar2, avatar3, avatar4, avatar6, avatar7, avatar8, avatar9 } from '../../assets/images';
import { IconEdit, IconMail, IconTrash } from '@tabler/icons-react';

export default function EmployeeSalary() {

  const columnsFilter = [
    {
      name: 'Avatar',
      selector: row => row.avatar,
      width: "100px",
    },
    {
      name: 'Name',
      selector: row => row.name,
      sortable: true,
    },
    {
      name: 'Email',
      selector: row => row.email,
      sortable: true,
    },
    {
      name: 'Employee ID',
      selector: row => row.employeeId,
      sortable: true,
    },
    {
      name: 'Phone',
      selector: row => row.phone,
      sortable: true,
    },
    {
      name: 'Join Date',
      selector: row => row.joinDate,
      sortable: true,
    },
    {
      name: 'Role',
      selector: row => row.role,
      sortable: true,
    },
    {
      name: 'Salary',
      selector: row => row.salary,
      sortable: true,
      width: '120px'
    },
    {
      name: 'Action',
      selector: row => row.action,
      width: '165px'
    },
  ];

  const dataFilter = [
    {
      avatar: <img src={avatar1} alt='profile' width="40" height="40" className='w-[40px] h-[40px] border border-bg-light object-cover rounded-full' />,
      name: 'Marshall Nichols',
      email: 'marshall-n@gmail.com',
      employeeId: 'LA-0215',
      phone: '+ 264-625-2583',
      joinDate: '24 Jun, 2015',
      role: 'Web Designer',
      salary: '$589',
      action:
        <div className='flex items-stretch gap-10'>
          <button title='mail' className='bg-primary rounded-[4px] px-10 py-[8px]'>
            <IconMail className='text-white w-[18px] h-[18px]' />
          </button>
          <button title='edit' className='bg-sky rounded-[4px] px-10 py-[8px]'>
            <IconEdit className='text-white w-[18px] h-[18px]' />
          </button>
          <button title='delete' className='bg-danger rounded-[4px] px-10 py-[8px]'>
            <IconTrash className='text-white w-[18px] h-[18px]' />
          </button>
        </div>,
    },
    {
      avatar: <img src={avatar2} alt='profile' width="40" height="40" className='w-[40px] h-[40px] border border-bg-light object-cover rounded-full' />,
      name: 'Susie Willis',
      email: 'sussie-w@gmail.com',
      employeeId: 'LA-0216',
      phone: '+ 264-625-2583',
      joinDate: '28 Jun, 2015',
      role: 'Web Developer',
      salary: '$650',
      action:
        <div className='flex items-stretch gap-10'>
          <button title='mail' className='bg-primary rounded-[4px] px-10 py-[8px]'>
            <IconMail className='text-white w-[18px] h-[18px]' />
          </button>
          <button title='edit' className='bg-sky rounded-[4px] px-10 py-[8px]'>
            <IconEdit className='text-white w-[18px] h-[18px]' />
          </button>
          <button title='delete' className='bg-danger rounded-[4px] px-10 py-[8px]'>
            <IconTrash className='text-white w-[18px] h-[18px]' />
          </button>
        </div>,
    },
    {
      avatar: <img src={avatar1} alt='profile' width="40" height="40" className='w-[40px] h-[40px] border border-bg-light object-cover rounded-full' />,
      name: 'Marshall Nichols',
      email: 'marshall-n@gmail.com',
      employeeId: 'LA-0215',
      phone: '+ 264-625-2583',
      joinDate: '24 Jun, 2015',
      role: 'Web Designer',
      salary: '$700',
      action:
        <div className='flex items-stretch gap-10'>
          <button title='mail' className='bg-primary rounded-[4px] px-10 py-[8px]'>
            <IconMail className='text-white w-[18px] h-[18px]' />
          </button>
          <button title='edit' className='bg-sky rounded-[4px] px-10 py-[8px]'>
            <IconEdit className='text-white w-[18px] h-[18px]' />
          </button>
          <button title='delete' className='bg-danger rounded-[4px] px-10 py-[8px]'>
            <IconTrash className='text-white w-[18px] h-[18px]' />
          </button>
        </div>,
    },
    {
      avatar: <img src={avatar3} alt='profile' width="40" height="40" className='w-[40px] h-[40px] border border-bg-light object-cover rounded-full' />,
      name: 'Debra Stewart',
      email: 'debra@gmail.com',
      employeeId: 'LA-0218',
      phone: '+ 264-625-2583',
      joinDate: '21 July, 2015',
      role: 'Web Developer',
      salary: '$589',
      action:
        <div className='flex items-stretch gap-10'>
          <button title='mail' className='bg-primary rounded-[4px] px-10 py-[8px]'>
            <IconMail className='text-white w-[18px] h-[18px]' />
          </button>
          <button title='edit' className='bg-sky rounded-[4px] px-10 py-[8px]'>
            <IconEdit className='text-white w-[18px] h-[18px]' />
          </button>
          <button title='delete' className='bg-danger rounded-[4px] px-10 py-[8px]'>
            <IconTrash className='text-white w-[18px] h-[18px]' />
          </button>
        </div>,
    },
    {
      avatar: <img src={avatar4} alt='profile' width="40" height="40" className='w-[40px] h-[40px] border border-bg-light object-cover rounded-full' />,
      name: 'Francisco Vasquez',
      email: 'francis-v@gmail.com',
      employeeId: 'LA-0222',
      phone: '+ 264-625-2583',
      joinDate: '18 Jan, 2016',
      role: 'Team Leader',
      salary: '$600',
      action:
        <div className='flex items-stretch gap-10'>
          <button title='mail' className='bg-primary rounded-[4px] px-10 py-[8px]'>
            <IconMail className='text-white w-[18px] h-[18px]' />
          </button>
          <button title='edit' className='bg-sky rounded-[4px] px-10 py-[8px]'>
            <IconEdit className='text-white w-[18px] h-[18px]' />
          </button>
          <button title='delete' className='bg-danger rounded-[4px] px-10 py-[8px]'>
            <IconTrash className='text-white w-[18px] h-[18px]' />
          </button>
        </div>,
    },
    {
      avatar: <img src={avatar6} alt='profile' width="40" height="40" className='w-[40px] h-[40px] border border-bg-light object-cover rounded-full' />,
      name: 'Jane Hunt',
      email: 'jane-hunt@gmail.com',
      employeeId: 'LA-0232',
      phone: '+ 264-625-2583',
      joinDate: '08 Mar, 2016',
      role: 'Android Developer',
      salary: '$700',
      action:
        <div className='flex items-stretch gap-10'>
          <button title='mail' className='bg-primary rounded-[4px] px-10 py-[8px]'>
            <IconMail className='text-white w-[18px] h-[18px]' />
          </button>
          <button title='edit' className='bg-sky rounded-[4px] px-10 py-[8px]'>
            <IconEdit className='text-white w-[18px] h-[18px]' />
          </button>
          <button title='delete' className='bg-danger rounded-[4px] px-10 py-[8px]'>
            <IconTrash className='text-white w-[18px] h-[18px]' />
          </button>
        </div>,
    },
    {
      avatar: <img src={avatar7} alt='profile' width="40" height="40" className='w-[40px] h-[40px] border border-bg-light object-cover rounded-full' />,
      name: 'Darryl Day',
      email: 'darryl.day@gmail.com',
      employeeId: 'LA-0233',
      phone: '+ 264-625-2583',
      joinDate: '13 Nov, 2016',
      role: 'IOS Developer',
      salary: '$589',
      action:
        <div className='flex items-stretch gap-10'>
          <button title='mail' className='bg-primary rounded-[4px] px-10 py-[8px]'>
            <IconMail className='text-white w-[18px] h-[18px]' />
          </button>
          <button title='edit' className='bg-sky rounded-[4px] px-10 py-[8px]'>
            <IconEdit className='text-white w-[18px] h-[18px]' />
          </button>
          <button title='delete' className='bg-danger rounded-[4px] px-10 py-[8px]'>
            <IconTrash className='text-white w-[18px] h-[18px]' />
          </button>
        </div>,
    },
    {
      avatar: <img src={avatar8} alt='profile' width="40" height="40" className='w-[40px] h-[40px] border border-bg-light object-cover rounded-full' />,
      name: 'Marshall Nichols',
      email: 'marshall-n@gmail.com',
      employeeId: 'LA-0215',
      phone: '+ 264-625-2583',
      joinDate: '24 Jun, 2015',
      role: 'Web Designer',
      salary: '$600',
      action:
        <div className='flex items-stretch gap-10'>
          <button title='mail' className='bg-primary rounded-[4px] px-10 py-[8px]'>
            <IconMail className='text-white w-[18px] h-[18px]' />
          </button>
          <button title='edit' className='bg-sky rounded-[4px] px-10 py-[8px]'>
            <IconEdit className='text-white w-[18px] h-[18px]' />
          </button>
          <button title='delete' className='bg-danger rounded-[4px] px-10 py-[8px]'>
            <IconTrash className='text-white w-[18px] h-[18px]' />
          </button>
        </div>,
    },
    {
      avatar: <img src={avatar9} alt='profile' width="40" height="40" className='w-[40px] h-[40px] border border-bg-light object-cover rounded-full' />,
      name: 'Susie Willis',
      email: 'sussie-w@gmail.com',
      employeeId: 'LA-0216',
      phone: '+ 264-625-2583',
      joinDate: '28 Jun, 2015',
      role: 'Web Developer',
      salary: '$700',
      action:
        <div className='flex items-stretch gap-10'>
          <button title='mail' className='bg-primary rounded-[4px] px-10 py-[8px]'>
            <IconMail className='text-white w-[18px] h-[18px]' />
          </button>
          <button title='edit' className='bg-sky rounded-[4px] px-10 py-[8px]'>
            <IconEdit className='text-white w-[18px] h-[18px]' />
          </button>
          <button title='delete' className='bg-danger rounded-[4px] px-10 py-[8px]'>
            <IconTrash className='text-white w-[18px] h-[18px]' />
          </button>
        </div>,
    },
    {
      avatar: <img src={avatar10} alt='profile' width="40" height="40" className='w-[40px] h-[40px] border border-bg-light object-cover rounded-full' />,
      name: 'Marshall Nichols',
      email: 'marshall-n@gmail.com',
      employeeId: 'LA-0215',
      phone: '+ 264-625-2583',
      joinDate: '24 Jun, 2015',
      role: 'Web Designer',
      salary: '$589',
      action:
        <div className='flex items-stretch gap-10'>
          <button title='mail' className='bg-primary rounded-[4px] px-10 py-[8px]'>
            <IconMail className='text-white w-[18px] h-[18px]' />
          </button>
          <button title='edit' className='bg-sky rounded-[4px] px-10 py-[8px]'>
            <IconEdit className='text-white w-[18px] h-[18px]' />
          </button>
          <button title='delete' className='bg-danger rounded-[4px] px-10 py-[8px]'>
            <IconTrash className='text-white w-[18px] h-[18px]' />
          </button>
        </div>,
    },
    {
      avatar: <img src={avatar11} alt='profile' width="40" height="40" className='w-[40px] h-[40px] border border-bg-light object-cover rounded-full' />,
      name: 'Debra Stewart',
      email: 'debra@gmail.com',
      employeeId: 'LA-0218',
      phone: '+ 264-625-2583',
      joinDate: '21 July, 2015',
      role: 'Web Developer',
      salary: '$600',
      action:
        <div className='flex items-stretch gap-10'>
          <button title='mail' className='bg-primary rounded-[4px] px-10 py-[8px]'>
            <IconMail className='text-white w-[18px] h-[18px]' />
          </button>
          <button title='edit' className='bg-sky rounded-[4px] px-10 py-[8px]'>
            <IconEdit className='text-white w-[18px] h-[18px]' />
          </button>
          <button title='delete' className='bg-danger rounded-[4px] px-10 py-[8px]'>
            <IconTrash className='text-white w-[18px] h-[18px]' />
          </button>
        </div>,
    },
    {
      avatar: <img src={avatar12} alt='profile' width="40" height="40" className='w-[40px] h-[40px] border border-bg-light object-cover rounded-full' />,
      name: 'Francisco Vasquez',
      email: 'francis-v@gmail.com',
      employeeId: 'LA-0222',
      phone: '+ 264-625-2583',
      joinDate: '18 Jan, 2016',
      role: 'Team Leader',
      salary: '$700',
      action:
        <div className='flex items-stretch gap-10'>
          <button title='mail' className='bg-primary rounded-[4px] px-10 py-[8px]'>
            <IconMail className='text-white w-[18px] h-[18px]' />
          </button>
          <button title='edit' className='bg-sky rounded-[4px] px-10 py-[8px]'>
            <IconEdit className='text-white w-[18px] h-[18px]' />
          </button>
          <button title='delete' className='bg-danger rounded-[4px] px-10 py-[8px]'>
            <IconTrash className='text-white w-[18px] h-[18px]' />
          </button>
        </div>,
    },
    {
      avatar: <img src={avatar13} alt='profile' width="40" height="40" className='w-[40px] h-[40px] border border-bg-light object-cover rounded-full' />,
      name: 'Jane Hunt',
      email: 'jane-hunt@gmail.com',
      employeeId: 'LA-0232',
      phone: '+ 264-625-2583',
      joinDate: '08 Mar, 2016',
      role: 'Android Developer',
      salary: '$589',
      action:
        <div className='flex items-stretch gap-10'>
          <button title='mail' className='bg-primary rounded-[4px] px-10 py-[8px]'>
            <IconMail className='text-white w-[18px] h-[18px]' />
          </button>
          <button title='edit' className='bg-sky rounded-[4px] px-10 py-[8px]'>
            <IconEdit className='text-white w-[18px] h-[18px]' />
          </button>
          <button title='delete' className='bg-danger rounded-[4px] px-10 py-[8px]'>
            <IconTrash className='text-white w-[18px] h-[18px]' />
          </button>
        </div>,
    },
  ]

  const [filterText, setFilterText] = React.useState('');
  const [resetPaginationToggle, setResetPaginationToggle] = React.useState(false);
  const filteredItems = dataFilter.filter(
    item =>
      item.name.toLowerCase().includes(filterText.toLowerCase()) ||
      item.employeeId.toLowerCase().includes(filterText.toLowerCase()) ||
      item.phone.toLowerCase().includes(filterText.toLowerCase()) ||
      item.joinDate.toLowerCase().includes(filterText.toLowerCase()) ||
      item.role.toLowerCase().includes(filterText.toLowerCase()) ||
      item.salary.toLowerCase().includes(filterText.toLowerCase())
  );

  const subHeaderComponentMemo = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText('');
      }
    };

    return (
      <div className='flex gap-5 mb-10 w-full justify-end'>
        <div className='relative w-full max-w-[221px]'>
          <input
            type='text'
            id='search'
            value={filterText}
            onChange={e => setFilterText(e.target.value)}
            placeholder='Search here...'
            className='bg-bg-light border border-border w-full py-[6px] px-3 min-h-[40px] rounded-[4px] placeholder:text-text-secondary focus:outline-none'
          />
        </div>
        <button onClick={handleClear} className="btn btn-danger">
          Clear
        </button>
      </div>
    );
  }, [filterText, resetPaginationToggle]);

  return (
    <>
      <Breadcrumb title="Employee Salary" path="Payroll / Employee Salary" />
      <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15'>
        <div className='react-data-table'>
          <ReactDataTable
            columns={columnsFilter}
            data={filteredItems}
            pagination
            paginationResetDefaultPage={resetPaginationToggle}
            subHeader
            subHeaderComponent={subHeaderComponentMemo}
          />
        </div>
      </div>
    </>
  )
}
